import { render, staticRenderFns } from "./ImageGalleryBlock.vue?vue&type=template&id=4a42067d&scoped=true&"
import script from "./ImageGalleryBlock.vue?vue&type=script&lang=js&"
export * from "./ImageGalleryBlock.vue?vue&type=script&lang=js&"
import style0 from "./ImageGalleryBlock.vue?vue&type=style&index=0&id=4a42067d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a42067d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a42067d')) {
      api.createRecord('4a42067d', component.options)
    } else {
      api.reload('4a42067d', component.options)
    }
    module.hot.accept("./ImageGalleryBlock.vue?vue&type=template&id=4a42067d&scoped=true&", function () {
      api.rerender('4a42067d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/ImageGalleryBlock.vue"
export default component.exports